import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';

import { siteConfig } from '../../config/site';

import '../../styles/Footer/Footer.scss';

const Footer = () => {
  const year = new Date().getFullYear();

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p className="footer__brand" aria-hidden="true">
          {siteConfig.displayName}
          <span>.</span>
        </p>
        <div className="footer__row">
          <p className="footer__copy">
            © {year} {siteConfig.displayName}. Designed &amp; built with React.
          </p>
          <div className="footer__links">
            <a href={siteConfig.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href={siteConfig.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <button type="button" className="footer__top" onClick={toTop}>
              Back to top <FontAwesomeIcon icon={faArrowUp} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
